var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg010LogOut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FF6C37;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ARROW_48"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M307.7,347.5c-13.3,0-24,10.7-24,24v58.5c0,18.7-15.2,33.9-33.9,33.9H82.1c-18.7,0-33.9-15.2-33.9-33.9V82.1 c0-18.7,15.2-33.9,33.9-33.9h167.7c18.7,0,33.9,15.2,33.9,33.9v50.5c0,13.3,10.7,24,24,24s24-10.7,24-24V82.1 C331.6,36.9,295,0.2,249.8,0.2H82.1C36.9,0.2,0.2,36.9,0.2,82.1v347.9c0.1,45.2,36.7,81.8,81.9,81.9h167.7 c45.2-0.1,81.8-36.7,81.9-81.9v-58.5C331.7,358.2,320.9,347.5,307.7,347.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M504.8,238.5l-85.4-85.4c-9.2-9.2-24.2-9.4-33.6-0.3c-9.7,9.3-9.5,25.1,0,34.7l44.5,44.5h-208 c-13.3,0-24,10.7-24,24c0,13.3,10.7,24,24,24h208l-44.9,44.9c-9.4,9.4-9.4,24.6,0,33.9s24.6,9.4,33.9,0l0,0l85.4-85.4 C514.4,263.8,514.4,248.2,504.8,238.5C504.8,238.6,504.8,238.5,504.8,238.5L504.8,238.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg010LogOut);
export default __webpack_public_path__ + "static/media/010-log-out.04050d9bcc0a30c120f6a6e54b4ba950.svg";
export { ForwardRef as ReactComponent };